import { reactive } from "vue";

// App code → flag asset name. Most codes resolve to their own SVG (e.g. "de" →
// "de-flag.svg"); the entries below share one asset so we don't commit multiple
// identical copies. India's five languages (hi/ta-in/bn-in/te/mr) all point at
// the single "in-flag.svg". Add an entry here when a new language should reuse
// an existing flag rather than ship its own.
const FLAG_ASSET_ALIASES = Object.freeze({
  hi: "in",
  "ta-in": "in",
  "bn-in": "in",
  te: "in",
  mr: "in",
});

export const flagsStore = reactive({
  flags: {},
  importFlags() {
    let r = require.context("@/assets/flags/", false, /\.svg$/);
    let flags = {};
    r.keys().map((item) => {
      flags[item.replace("./", "")] = r(item);
    });
    this.flags = flags;
  },
  getFlag(countryCode) {
    if (Object.keys(this.flags).length === 0) this.importFlags();
    const asset = FLAG_ASSET_ALIASES[countryCode] || countryCode;
    return this.flags[asset + "-flag.svg"];
  },
});
